// src/components/layout/AppContent.js
// Outer canônico de toda page do AppShell (2026-05-11, Fase 8).
//
// Padrão: max-width 1440px mx auto + padding responsivo. Tabelas/listings/forms
// crescem até esse teto e centralizam acima dele. Substitui o
// <Box sx={{ px: { xs: 2, md: 3 }, pt: 2, pb: 4 }}> outer espalhado em 28 pages.
//
// Props:
//   fullBleed — DashboardGeral: ocupa 100% (sem teto). Default false.
//   sx — sx overrides adicionais (composto via spread).
//   children — conteúdo da page.

import React from 'react'
import { Box } from '@mui/material'

const APP_CONTENT_MAX_WIDTH = 1440

export default function AppContent({ children, sx, fullBleed = false, ...rest }) {
  return (
    <Box
      component="main"
      sx={{
        maxWidth: fullBleed ? '100%' : APP_CONTENT_MAX_WIDTH,
        mx: 'auto',
        px: { xs: 2, md: 3 },
        pt: 2,
        pb: 4,
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Box>
  )
}
